
{
  "familyId": "GET-BREUK-RASTER",
  "questions": [
    {
      "id": "GET-BREUK-RASTER-001",
      "familyId": "GET-BREUK-RASTER",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_raster_arceren",
      "questionType": "grid_shade",
      "question": "Arceer $\\frac{3}{8}$ van het rooster.",
      "context": null,
      "data": {
        "gridShade": {
          "gridRows": 2,
          "gridCols": 4,
          "targetCount": 3,
          "mode": "shade_count",
          "showCounter": true
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk en rooster",
            "content": "De noemer (8) vertelt hoeveel vakjes er totaal zijn. De teller (3) vertelt hoeveel vakjes je moet arceren. Tel het totaal: 2 × 4 = 8 vakjes. Arceer er 3.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_raster_shade_count_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Het rooster heeft 2 rijen × 4 kolommen = 8 vakjes. De breuk $\\frac{3}{8}$ betekent: arceer 3 van de 8 vakjes.",
        "solutionSteps": [
          "Tel het totaal aantal vakjes: 2 × 4 = 8",
          "De teller is 3 → arceer 3 vakjes",
          "Het maakt niet uit welke 3 vakjes je kiest"
        ]
      },
      "pedagogy": { "dok": 1 }
    },
    {
      "id": "GET-BREUK-RASTER-002",
      "familyId": "GET-BREUK-RASTER",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_raster_arceren",
      "questionType": "grid_shade",
      "question": "Arceer de helft van het rooster.",
      "context": null,
      "data": {
        "gridShade": {
          "gridRows": 2,
          "gridCols": 3,
          "targetCount": 3,
          "mode": "shade_count",
          "showCounter": true
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De helft",
            "content": "De helft = $\\frac{1}{2}$. Tel het totaal: 2 × 3 = 6 vakjes. De helft van 6 = 3. Arceer 3 vakjes.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_raster_shade_helft",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Het rooster heeft 6 vakjes. De helft van 6 = 3. Arceer dus 3 van de 6 vakjes.",
        "solutionSteps": [
          "Tel het totaal: 2 × 3 = 6 vakjes",
          "De helft van 6 = 3",
          "Arceer 3 vakjes"
        ]
      },
      "pedagogy": { "dok": 1 }
    },
    {
      "id": "GET-BREUK-RASTER-003",
      "familyId": "GET-BREUK-RASTER",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_raster_arceren",
      "questionType": "grid_shade",
      "question": "Er zijn al 2 vakjes gearceerd. Arceer er meer zodat in totaal $\\frac{5}{10}$ gearceerd is.",
      "context": null,
      "data": {
        "gridShade": {
          "gridRows": 2,
          "gridCols": 5,
          "targetCount": 5,
          "mode": "shade_count",
          "preShaded": [0, 1],
          "showCounter": true
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aanvullen tot een breuk",
            "content": "Er zijn 10 vakjes totaal. Je moet $\\frac{5}{10}$ arceren, dus 5 vakjes. Er zijn al 2 gearceerd, dus je moet er nog 3 bijkleuren.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_raster_aanvullen",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het rooster heeft 2 × 5 = 10 vakjes. $\\frac{5}{10}$ = 5 vakjes arceren. Er zijn al 2 gearceerd, dus je moet er nog 3 bij arceren.",
        "solutionSteps": [
          "Totaal: 2 × 5 = 10 vakjes",
          "$\\frac{5}{10}$ → 5 vakjes moeten gearceerd zijn",
          "Er zijn al 2 gearceerd → nog 3 erbij"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "GET-BREUK-RASTER-004",
      "familyId": "GET-BREUK-RASTER",
      "module": "Getalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_raster_arceren",
      "questionType": "grid_shade",
      "question": "Arceer $\\frac{3}{4}$ van het rooster.",
      "context": null,
      "data": {
        "gridShade": {
          "gridRows": 3,
          "gridCols": 4,
          "targetCount": 9,
          "mode": "shade_fraction",
          "showCounter": true
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "3 van de 4 delen",
            "visualType": "bar",
            "showEaten": false
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk van een rooster",
            "content": "Het rooster heeft 3 × 4 = 12 vakjes. $\\frac{3}{4}$ van 12 = 12 ÷ 4 × 3 = 9 vakjes.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_raster_shade_fraction",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het rooster heeft 3 × 4 = 12 vakjes. $\\frac{3}{4}$ van 12: deel door 4 → 3, keer 3 → 9. Arceer 9 vakjes.",
        "solutionSteps": [
          "Totaal: 3 × 4 = 12 vakjes",
          "12 ÷ 4 = 3 (één kwart)",
          "3 × 3 = 9 (drie kwart)",
          "Arceer 9 vakjes"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "GET-BREUK-RASTER-005",
      "familyId": "GET-BREUK-RASTER",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_raster_arceren",
      "questionType": "grid_shade",
      "question": "Arceer 25% van het rooster.",
      "context": null,
      "data": {
        "gridShade": {
          "gridRows": 4,
          "gridCols": 4,
          "targetCount": 4,
          "mode": "shade_count",
          "showCounter": true
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "percentagebar",
          "showWhen": "wrong",
          "data": {
            "percentage": 25,
            "label": "25% = een kwart"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Procent naar aantal",
            "content": "25% = $\\frac{25}{100}$ = $\\frac{1}{4}$. Het rooster heeft 4 × 4 = 16 vakjes. $\\frac{1}{4}$ van 16 = 4 vakjes.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_raster_procent",
      "variantIndex": 1,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "25% = $\\frac{1}{4}$. Het rooster heeft 4 × 4 = 16 vakjes. Een kwart van 16 = 4. Arceer 4 vakjes.",
        "solutionSteps": [
          "25% = $\\frac{1}{4}$",
          "Totaal: 4 × 4 = 16 vakjes",
          "$\\frac{1}{4}$ van 16 = 4",
          "Arceer 4 vakjes"
        ]
      },
      "pedagogy": { "dok": 2 }
    }
  ]
}
